import React from "react";
import "../OurStory/KeyExpertise.css";
import { AirFrieghtService } from "../OurStory/KeyData";

const Card = ({ title, content, icon, animation }) => {
  return (
    <div className="cards-sea" data-aos={animation}>
      <div id="icon-container">
        <i id="icon" className={icon}></i>
      </div>
      <div className="user-info">
        <h2 className="card-title">{title}</h2>
        <p className="card-content">{content}</p>
      </div>
    </div>
  );
};

const AirFreightService = () => {
  return (
    <>
      <div className="key-heading" data-aos="slide-right">
        <h3>Our Range of Air Freight Service</h3>
      </div>
      <div className="card-container">
        {AirFrieghtService.map((card, index) => (
          <Card
            key={index}
            icon={card.icon}
            title={card.title}
            content={card.content}
            animation={card.animation}
          />
        ))}
      </div>
    </>
  );
};

export default AirFreightService;
